import { NgModule } from '@angular/core';

import { HasChannelFeatureDirective } from './has-channel-feature.directive';
import { HasDealerSettingsDirective } from './has-dealer-settings.directive';
import { HasMessagingPermissionsDirective } from './has-permissions.directive';
import { HasWorkspaceFeatureDirective } from './has-workspce-feature.directive';
import { MatAutocompleteOptionsScrollDirective } from './mat-auto-complete-scroll.directive';

@NgModule({
  declarations: [
    HasWorkspaceFeatureDirective,
    HasChannelFeatureDirective,
    MatAutocompleteOptionsScrollDirective,
    HasDealerSettingsDirective,
    HasMessagingPermissionsDirective,
  ],
  exports: [
    HasWorkspaceFeatureDirective,
    MatAutocompleteOptionsScrollDirective,
    HasDealerSettingsDirective,
    HasChannelFeatureDirective,
    HasMessagingPermissionsDirective,
  ],
})
export class DirectivesModule {}
